// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Gt-z","articleImagesWrap":"Ht-z","articleImage":"It-z","singleImage":"Jt-z"};